import * as React from 'react';

import { HeartIcon, HeartOIcon } from '@notino/react-styleguide';

import { useNewPdDesignEnabled } from '@containers/ProductDetailContainer/ProductDetail/hooks/useNewPdDesignEnabled';

import { StyledPulsatingHeart } from './styled';

interface IPulsatingHeartProps {
  wishlisted: boolean;
  loading: boolean;
  width?: string;
  height?: string;
}

export const PulsatingHeart: React.FC<IPulsatingHeartProps> = ({
  wishlisted,
  loading,
}) => {
  const newPdDesignEnabled = useNewPdDesignEnabled();

  return (
    <StyledPulsatingHeart
      data-cypress="wishlist"
      animate={loading}
      newPdDesignEnabled={newPdDesignEnabled}
    >
      {wishlisted || loading ? (
        <HeartIcon width="20px" height="20px" color="icon.highlight" />
      ) : (
        <HeartOIcon width="20px" height="20px" color="icon.primary" />
      )}
    </StyledPulsatingHeart>
  );
};
